import {
  SUBTITLE_SIZE_OPTIONS,
  SUBTITLE_COLOR_OPTIONS,
  SUBTITLE_STROKE_OPTIONS,
  SUBTITLE_BACKGROUND_OPTIONS,
} from 'src/interfaces/enums';
import * as yup from 'yup';
import { schemaDefault } from '../../SchemaDefault';

export default {
  change: schemaDefault.concat(
    yup
      .object()
      .shape({
        size: yup.mixed<SUBTITLE_SIZE_OPTIONS>().oneOf(Object.values(SUBTITLE_SIZE_OPTIONS)),
        color: yup.mixed<SUBTITLE_COLOR_OPTIONS>().oneOf(Object.values(SUBTITLE_COLOR_OPTIONS)),
        stroke: yup.mixed<SUBTITLE_STROKE_OPTIONS>().oneOf(Object.values(SUBTITLE_STROKE_OPTIONS)),
        background: yup.mixed<SUBTITLE_BACKGROUND_OPTIONS>().oneOf(Object.values(SUBTITLE_BACKGROUND_OPTIONS)),
      })
      .strict(),
  ),
};
